import React, { createContext, useContext } from 'react';
import { errorMessageDuplicateCommonCore } from './constants';
var PfFlagsContext = /*#__PURE__*/createContext(undefined);
/**
 * @private
 * @deprecated Do not use `PfFlagsProvder` anymore. Use `getBooleanFF` from `@atlaskit/platform-feature-flags` to access feature flags instead.
 */
export var PfFlagsProvider = function PfFlagsProvider(_ref) {
  var flags = _ref.flags,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(PfFlagsContext.Provider, {
    value: flags
  }, children);
};

/**
 * @private
 * @deprecated Do not use `usePfFlags` anymore. Use `getBooleanFF` from `@atlaskit/platform-feature-flags` to access feature flags instead.
 */
export function usePfFlags() {
  var flags = useContext(PfFlagsContext);
  if (flags === undefined) {
    throw new Error("usePfFlags must be used within a PfFlagsProvider. ".concat(errorMessageDuplicateCommonCore));
  }
  return flags;
}